module.exports = __webpack_public_path__ + "img/a1.b7540445.png";